import { InjectionToken } from '@angular/core';
import { AppNavigationsSettings } from '@common-modules/navigation/models/app-navigations-settings';

export const APP_NAVIGATIONS = new InjectionToken<AppNavigationsSettings>('APP_NAVIGATIONS');
